import { Skeleton, Stack } from '@mui/material';
import { Show, useIsMobile } from '@side/pantry';
import { contentContainerSx } from '@/theme/contentContainerSx';
import { FormContainer as NewInteractionFormContainer } from '../../NewInteraction/FormContainer';

/**
 * Placeholder shown while the deep-link prefill resolves. Mirrors the Step 1
 * layout (header, MLS + address cards, status select, actions, side stepper)
 * so the transition into the real wizard doesn't shift the page.
 */
export const CreateOfferSkeleton = () => {
  const isMobile = useIsMobile('lg');

  return (
    <NewInteractionFormContainer>
      <Stack
        data-testid="create-offer-skeleton"
        sx={{
          ...contentContainerSx,
          pt: { xs: 2, lg: 3 },
          pb: { xs: 4.5, lg: 7 },
        }}
      >
        <Stack sx={{ gap: 1, mb: { xs: 2, lg: 4 } }}>
          <Skeleton variant="text" width={220} height={32} />
          <Skeleton variant="text" width={360} height={20} />
        </Stack>

        <Stack
          direction={{ xs: 'column-reverse', lg: 'row' }}
          sx={{ gap: { xs: 2, lg: 7.5 } }}
        >
          <Stack sx={{ flex: 1, gap: 4 }}>
            <Skeleton variant="rounded" height={180} />
            <Skeleton variant="rounded" height={220} />
            <Skeleton variant="rounded" height={90} />
            <Stack
              direction={{ xs: 'column', lg: 'row' }}
              sx={{ gap: 2, justifyContent: { lg: 'flex-end' } }}
            >
              <Skeleton variant="rounded" width={120} height={48} />
              <Skeleton variant="rounded" width={120} height={48} />
            </Stack>
          </Stack>

          <Show when={!isMobile}>
            <Skeleton variant="rounded" width={240} height={160} />
          </Show>
        </Stack>
      </Stack>
    </NewInteractionFormContainer>
  );
};
